"use client"

import { useTranslations } from "@/lib/intl/use-translations"

export function CrossBorderStep() {
  const t = useTranslations("crossBorder.step")
  return (
    <section className="my-12 rounded-[16px] bg-white p-8 md:p-12">
      <h2 className="type-display-sm text-balance text-neutral-900">
        {t("title")}
      </h2>
      <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-12">
        <div>
          <p className="type-label-lg mb-3 text-neutral-400 uppercase">
            {t("germanyHeading")}
          </p>
          <p className="type-body-lg leading-relaxed text-neutral-600">
            {t("germanyBody")}
          </p>
        </div>
        <div>
          <p className="type-label-lg mb-3 text-neutral-400 uppercase">
            {t("switzerlandHeading")}
          </p>
          <p className="type-body-lg leading-relaxed text-neutral-600">
            {t("switzerlandBody")}
          </p>
        </div>
      </div>
      <p className="type-body-md mt-8 text-neutral-500">{t("footer")}</p>
    </section>
  )
}
